(() => {
  if (window.saleSliderManager) {
    window.saleSliderManager.init(document);
    return;
  }
  const instances = new Map();
  const init = (scope) => {
    scope.querySelectorAll('.school-sale').forEach((section) => {
      if (instances.has(section)) return;
      const slider = section.querySelector('[data-school-slider]');
      const viewport = section.querySelector('.school-sale__viewport');
      const track = section.querySelector('[data-school-track]');
      const slides = [...section.querySelectorAll('[data-school-slide]')];
      const dots = [...section.querySelectorAll('[data-school-dot]')];
      if (!slider || !viewport || !track || !slides.length) return;
      const controller = new AbortController();
      const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: controller.signal });
      let current = 0;
      let autoplayId;
      let countdownId;
      let editorSelected = false;
      let pointerStart;
      let suppressClick = false;
      const resize = () => {
        viewport.style.height = `${track.getBoundingClientRect().height}px`;
      };
      const goTo = (index) => {
        current = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${current * 100}%)`;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', String(i === current));
        });
        resize();
      };
      const stop = () => {
        clearInterval(autoplayId);
        autoplayId = undefined;
      };
      const start = () => {
        if (autoplayId || editorSelected || document.hidden || slider.dataset.autoplay !== 'true' || slides.length < 2) return;
        if ((matchMedia('(hover: hover)').matches && slider.matches(':hover')) || slider.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        autoplayId = setInterval(() => goTo(current + 1), Math.max(3000, Number(slider.dataset.delay) || 6000));
      };
      const restart = () => { stop(); start(); };
      dots.forEach((dot) => on(dot, 'click', () => { goTo(Number(dot.dataset.slideTo)); restart(); }));
      on(slider, 'mouseenter', () => { if (matchMedia('(hover: hover)').matches) stop(); });
      on(slider, 'mouseleave', start);
      on(slider, 'focusin', stop);
      on(slider, 'focusout', () => queueMicrotask(start));
      on(document, 'visibilitychange', () => document.hidden ? stop() : start());
      on(viewport, 'pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        suppressClick = false;
        stop();
      });
      on(window, 'pointerup', (event) => {
        if (!pointerStart || event.pointerId !== pointerStart.id) return;
        const dx = event.clientX - pointerStart.x;
        const dy = event.clientY - pointerStart.y;
        pointerStart = undefined;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          suppressClick = true;
          goTo(current + (dx < 0 ? 1 : -1));
        }
        restart();
      });
      on(window, 'pointercancel', () => { pointerStart = undefined; start(); });
      on(viewport, 'dragstart', (event) => event.preventDefault());
      on(viewport, 'click', (event) => {
        if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
      }, { capture: true });
      on(slider, 'keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        goTo(current + (event.key === 'ArrowRight' ? 1 : -1));
        restart();
      });
      const timers = [...section.querySelectorAll('[data-school-timer]')];
      const updateTimers = () => timers.forEach((timer) => {
        const end = Date.parse(timer.dataset.end || '');
        const remaining = Number.isFinite(end) ? Math.max(0, end - Date.now()) : 0;
        const units = { days: Math.floor(remaining / 86400000), hours: Math.floor(remaining / 3600000) % 24, minutes: Math.floor(remaining / 60000) % 60, seconds: Math.floor(remaining / 1000) % 60 };
        Object.entries(units).forEach(([unit, value]) => { timer.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2, '0'); });
      });
      on(document, 'shopify:block:select', (event) => {
        const selected = event.target.closest('[data-school-slide]');
        if (!selected || !section.contains(selected)) return;
        editorSelected = true;
        goTo(Number(selected.dataset.slideIndex));
        stop();
      });
      on(document, 'shopify:block:deselect', (event) => {
        if (!section.contains(event.target)) return;
        editorSelected = false;
        start();
      });
      const observer = new ResizeObserver(resize);
      slides.forEach((slide) => observer.observe(slide.querySelector('.school-sale__inner')));
      goTo(0);
      updateTimers();
      if (timers.length) countdownId = setInterval(updateTimers, 1000);
      start();
      instances.set(section, () => { controller.abort(); observer.disconnect(); stop(); clearInterval(countdownId); instances.delete(section); });
    });
  };
  window.saleSliderManager = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    [...instances.entries()].forEach(([section, destroy]) => { if (event.target.contains(section)) destroy(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
